import useIntercom from "@/hooks/useIntercom";
import { ReactNode, useState } from "react";
import MaterialImpactModal, {
  MaterialImpactReferenceModalProps,
} from "./MaterialImpactReferenceModal";

export interface ChangeImpactReferenceActionProps
  extends Omit<MaterialImpactReferenceModalProps, "onClose"> {
  children: ReactNode;
}

export default function ChangeImpactReferenceAction(props: ChangeImpactReferenceActionProps) {
  const [isOpen, setIsOpen] = useState(false);

  const { setMarginBottom } = useIntercom();

  const onOpen = () => {
    setIsOpen(true);
    setMarginBottom(85);
  };

  const onClose = () => {
    setIsOpen(false);
    setMarginBottom(0);
  };

  return (
    <>
      <span onClick={() => props.disabled !== true && onOpen()}>{props.children}</span>
      {isOpen && (
        <MaterialImpactModal
          {...props}
          onClose={() => onClose()}
        />
      )}
    </>
  );
}
